import { WebPlugin } from '@capacitor/core';
import { NetsSmartPosPlugin } from './definitions';

export class NetsSmartPosWeb extends WebPlugin implements NetsSmartPosPlugin {
  constructor() {
    super({
      name: 'NetsSmartPos',
      platforms: ['web'],
    });
  }

  async print(options: { lines: {text: string, align?: string, font?: string, size?: string}[] }): Promise<{ success: number }> {
    console.log('print', options);
    return {success: 1};
  }

  async pay(options: { amount: number, vat: number, currency: string }): Promise< {
      errorMessage: string;
      currency?:    string;
      sum?:         number;
      cardTerminalTransactionId?: string;
      authorization?:             string;
      cardTerminalUsageMode?:     string;
      rawPtData?:                 string;
     }> {
    console.log('pay from web', options);
    return {"errorMessage": "Web is not supported!"};
  }

  async  printSlip(options: {paymentUuid: string, copy: boolean}) : Promise<{}> {
    console.log("Web printing slip ", options);
    return {};
  }

}

const NetsSmartPos = new NetsSmartPosWeb();

export { NetsSmartPos };

import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(NetsSmartPos);
